var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNuget = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#004880",
  fillRule: "evenodd",
  d: "M16.912 20.366a3.47 3.47 0 1 1 0-6.939 3.47 3.47 0 0 1 0 6.939Zm-6.92-7.952a2.168 2.168 0 1 1 0-4.337 2.168 2.168 0 0 1 0 4.337Zm7.073-6.769h-5.79a5.346 5.346 0 0 0-5.343 5.346v5.79a5.345 5.345 0 0 0 5.344 5.344h5.79a5.343 5.343 0 0 0 5.344-5.345v-5.79a5.345 5.345 0 0 0-5.345-5.345Z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "nuget_svg__a",
  width: 5,
  height: 5,
  x: 1,
  y: 1,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1.566 3.61V1.874h3.47v3.469h-3.47V3.609Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#nuget_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#004880",
  fillRule: "evenodd",
  d: "M5.035 3.608a1.735 1.735 0 1 1-3.47 0 1.735 1.735 0 0 1 3.47 0Z",
  clipRule: "evenodd"
}))));
export default SvgNuget;